export const APPLICANT_CONTACT = 'applicant-contact';
export const PERSON_CONTACT = 'person-contact';
export const BILLING_ADDRESS = 'billing-address';
export const OTHER_DETAILS = 'other-details';
export const EXPRESS_LETTER_SERVICES = 'licence-details';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';
export const CORRESPONDENCE_DETAILS = 'corrsepondence-details';
export const BILLING_DETAILS = 'billing-details';

export const NEW_EXPRESSLETTER_APPLICATION = [
    {
        sectionID: CORRESPONDENCE_DETAILS,
        sectionName: 'Contact Person Particulars Details',
        fieldList: [
            {
                id: 'sameAsContactPersonParticulars',
                label: 'Same As Contact Person Particulars',
                type: 'text',
                span: 12
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'mobileNo',
                label: 'Mobile No',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'telNumber',
                label: 'Office No.',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'text',
                rule: { required: true, charLength: 32 },
                isNextEmpty: true
            }
        ]
    },
    {
        sectionID: BILLING_DETAILS,
        sectionName: 'Billing Person Particulars',
        fieldList: [
            {
                id: 'sameAsContactPersonParticulars',
                label: 'Same As Contact Person Particulars',
                type: 'text',
                span: 12
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'mobileNo',
                label: 'Mobile No',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'telNumber',
                label: 'Office No.',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email Address',
                type: 'text',
                rule: { required: true, charLength: 32 },
                isNextEmpty: true
            }
        ]
    },
    {
        sectionID: BILLING_ADDRESS,
        sectionName: 'Billing Address',
        fieldList: [
            {
                id: 'mailingAddress',
                label: 'Same As Mailing Address',
                type: 'text',
                isNextEmpty: true
            },
            {
                id: 'Postal',
                label: 'Postal Code',
                type: 'postal',
                rule: { required: true }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: { required: true, charLength: 32 }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: { charLength: 66 }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: 01, B1, 01M',
                rule: { charLength: 3 }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: #05-01, use 01',
                rule: { charLength: 5 },
                isNextEmpty: true
            },
            {
                id: 'renewal',
                label: 'Do you want your renewal be paid through GIRO?',
                type: 'text'
            },
            {
                id: 'imdaArrangement',
                label: 'Do you have an existing GIRO arrangement with IMDA?',
                type: 'text'
            },
            {
                id: 'bank',
                label: 'Bank',
                type: 'text'
            },
            {
                id: 'bankNumber',
                label: 'Bank account number',
                type: 'text'
            },
            {
                id: 'eInvoice',
                label: 'Do you require e-invoice on Vendors@gov',
                type: 'text'
            },
            {
                id: 'businessUnitNumber',
                label: 'Sub-business Unit Number',
                type: 'text'
            }
        ]
    },
    {
        sectionID: EXPRESS_LETTER_SERVICES,
        sectionName: 'Others',
        fieldList: [
            {
                id: 'types-express-letter',
                label: 'Type of Express Letter Services',
                type: 'text'
            },
            {
                id: 'public-contact-no',
                label: 'Public Contact No',
                type: 'text'
            },
            {
                id: 'use-of-system',
                label: 'Proposed Use of System',
                type: 'text',
                span: 12
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text',
                span: 12
            }
        ]
    },

    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file'
            }
        ]
    }
];
